(function() {
  // MOCK_USERS is now expected to be loaded externally from `mock-users.js`
  if (typeof MOCK_USERS === 'undefined') {
    console.error('MOCK_USERS is not defined. Please include mock-users.js before this script.');
    return;
  }

  // Debug mode configuration
  const DEBUG_MODE = false; // Set to true for static debug popup
  const DEBUG_DELAY = 1000; // 1 second delay for debug popup

  const MAX_POPUPS_PER_SESSION = 50;
  const MAX_POPUPS_PER_PAGE = 3;
  const SESSION_KEY = 'popup_display_count';
  const BLOCK_POPUPS_KEY = 'popup_blocked';
  const POPUP_DISPLAY_DURATION = 5000; // 5 seconds display time
  let pagePopupCount = 0;

  const MIN_DELAY = 1500; // 5 seconds
  const MAX_DELAY = 4500; // 15 seconds

  function getRandomTimeAgo() {
    const isRecent = Math.random() < 0.7;
    const minutes = isRecent
      ? Math.floor(Math.random() * 14) + 1
      : Math.floor(Math.random() * 36) + 14;
    return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
  }

  function canShowPopup() {
    const count = parseInt(sessionStorage.getItem(SESSION_KEY) || '0', 10);
    return count < MAX_POPUPS_PER_SESSION && pagePopupCount < MAX_POPUPS_PER_PAGE && !sessionStorage.getItem(BLOCK_POPUPS_KEY);
  }

  function incrementPopupCount() {
    const current = parseInt(sessionStorage.getItem(SESSION_KEY) || '0', 10);
    sessionStorage.setItem(SESSION_KEY, current + 1);
    pagePopupCount++;
  }

  function scheduleNextPopup() {
    if (pagePopupCount >= MAX_POPUPS_PER_PAGE) {
      console.log('[FOMO Popup Debug] Maximum popups per page reached');
      return;
    }

    const delay = Math.floor(Math.random() * (MAX_DELAY - MIN_DELAY)) + MIN_DELAY;
    const nextShowTime = new Date(Date.now() + delay);
    console.log(`[FOMO Popup Debug] Next popup scheduled to show at ${nextShowTime.toLocaleTimeString()} (in ${(delay/1000).toFixed(2)} seconds)`);
    
    setTimeout(() => {
      if (canShowPopup()) {
        getAndShowRandomRelatedProductPopup();
      } else {
        console.log('[FOMO Popup Debug] Cannot show popup - session limit reached or popups blocked');
      }
    }, delay);
  }

  function getAndShowRandomRelatedProductPopup() {
    try {
      const raw = document.getElementById("related-products-json")?.textContent;
      if (!raw) return;

      const relatedProducts = JSON.parse(raw);
      if (!Array.isArray(relatedProducts) || relatedProducts.length === 0) return;

      const randomProduct = relatedProducts[Math.floor(Math.random() * relatedProducts.length)];
      const randomUser = MOCK_USERS[Math.floor(Math.random() * MOCK_USERS.length)];
      const timeAgo = getRandomTimeAgo();

      // Trim product title using the same logic as PDP
      let trimmedTitle = randomProduct.title;
      const trimPattern = " - %s - ";
      let trimmed = false;
      
      // Try different number of digits (00, 01, 02, etc.)
      for (let i = 0; i < 100; i++) {
        // Format the number with leading zero if needed
        const num = i.toString().padStart(2, '0');
        const currentPattern = trimPattern.replace('%s', num);
        
        if (trimmedTitle.includes(currentPattern)) {
          trimmedTitle = trimmedTitle.split(currentPattern)[0].trim();
          trimmed = true;
          break;
        }
      }

      const textContent = `${randomUser.name} (${randomUser.city}, ${randomUser.state}) purchased ${trimmedTitle}`;
      const popupDuration = DEBUG_MODE ? Infinity : POPUP_DISPLAY_DURATION;

      const html = `
        <a href="${randomProduct.url}" target="_blank" id="popup-notification" style="
          position: fixed;
          bottom: var(--space-6);
          left: var(--space-6);
          z-index: 9999;
          background: var(--COLOR-BG);
          padding: var(--space-3) var(--space-4);
          border-radius: var(--radius-md);
          box-shadow: 0 8px 24px var(--COLOR-A20);
          max-width: 450px;
          width: 90vw;
          display: flex;
          align-items: center;
          gap: var(--space-2);
          font-family: var(--FONT-STACK-BODY);
          opacity: 0;
          transform: translateY(20px);
          transition: all 0.4s ease-in-out;
          text-decoration: none;
        ">

          <img src="${randomProduct.image}" alt="product" style="
            width: 70px;
            height: 70px;
            max-width: 18vw;
            height: auto;
            object-fit: cover;
            border-radius: var(--radius-sm);
            flex-shrink: 0;">

          <div style="flex: 1; line-height: var(--leading-normal); color: inherit; min-width: 0; padding-right: var(--space-2);">
            <div style="
              font-weight: var(--FONT-WEIGHT-BODY-BOLD);
              font-size: var(--font-3);
              color: var(--COLOR-TEXT-DARK);
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;">
              ${randomUser.name} <span style="opacity: 0.6; font-size: var(--font-2);">(${randomUser.city}, ${randomUser.state})</span>
            </div>
            <div style="font-size: var(--font-3); color: var(--COLOR-TEXT); margin-top: 2px;">
              purchased <span style="
                color: var(--COLOR-PRIMARY);
                font-weight: var(--FONT-WEIGHT-BODY-BOLD;">${trimmedTitle}</span>
            </div>
            <div style="font-size: var(--font-1); color: var(--COLOR-TEXT-LIGHT); margin-top: 2px;">
              ${timeAgo}
            </div>
          </div>

          <button style="
            position: absolute;
            top: 2px;
            right: 8px;
            background: none;
            border: none;
            font-size: 20px;
            color: var(--COLOR-TEXT-LIGHT);
            cursor: pointer;">&times;</button>
        </a>`;

      const container = document.createElement("div");
      container.innerHTML = html;
      const popup = container.firstElementChild;

      const closeButton = popup.querySelector("button");
      closeButton.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation(); // Prevent event from bubbling to document
        console.log('[FOMO Popup Debug] Popup closed by user click');
        closePopup();
        sessionStorage.setItem(BLOCK_POPUPS_KEY, 'true');
        console.log('[FOMO Popup Debug] Popups blocked for current session');
      });

      // Function to close popup and clean up
      function closePopup() {
        popup.style.opacity = '0';
        popup.style.transform = 'translateY(20px)';
        setTimeout(() => {
          popup.remove();
          document.removeEventListener('click', closePopupOnOutsideClick);
          document.removeEventListener('scroll', closePopupOnScroll);
        }, 400);
      }

      // Add click-outside behavior
      function closePopupOnOutsideClick(e) {
        if (!popup.contains(e.target)) {
          console.log('[FOMO Popup Debug] Popup closed by clicking outside');
          closePopup();
        }
      }
      document.addEventListener('click', closePopupOnOutsideClick);

      // Add scroll behavior
      function closePopupOnScroll() {
        console.log('[FOMO Popup Debug] Popup closed by page scroll');
        closePopup();
      }
      document.addEventListener('scroll', closePopupOnScroll, { passive: true });

      document.body.appendChild(popup);
      setTimeout(() => {
        popup.style.opacity = '1';
        popup.style.transform = 'translateY(0)';
      }, 50);

      incrementPopupCount();

      // In debug mode, don't auto-dismiss the popup
      if (!DEBUG_MODE) {
        setTimeout(() => {
          popup.style.opacity = '0';
          popup.style.transform = 'translateY(20px)';
          setTimeout(() => {
            popup.remove();
            scheduleNextPopup();
          }, 400);
        }, popupDuration);
      }

    } catch (e) {
      console.error("Popup error:", e);
    }
  }

  window.addEventListener("load", () => {
    if (window.location.pathname.includes("/products/")) {
      // Check and log popup blocking status
      const isBlocked = sessionStorage.getItem(BLOCK_POPUPS_KEY) === 'true';
      const popupCount = parseInt(sessionStorage.getItem(SESSION_KEY) || '0', 10);
      console.log(`[FOMO Popup Debug] Session Status - Popups Blocked: ${isBlocked}, Popups Shown: ${popupCount}/${MAX_POPUPS_PER_SESSION}`);

      if (DEBUG_MODE) {
        // In debug mode, show a single popup after 1 second
        setTimeout(() => {
          getAndShowRandomRelatedProductPopup();
        }, DEBUG_DELAY);
      } else if (canShowPopup()) {
        scheduleNextPopup();
      }
    }
  });
})();